export default __webpack_public_path__ + "static/media/reset_password.4ff2282c.webp";